import { useEffect } from "react";

export function useUnsavedChanges(dirty) {
  // Broadcast dirty state whenever it changes
  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent("sp-unsaved-changes", { detail: { dirty } }),
    );

    return () => {
      window.dispatchEvent(
        new CustomEvent("sp-unsaved-changes", { detail: { dirty: false } }),
      );
    };
  }, [dirty]);

  // Re-broadcast current state when header asks on mount
  useEffect(() => {
    const handleRequest = () => {
      window.dispatchEvent(
        new CustomEvent("sp-unsaved-changes", { detail: { dirty } }),
      );
    };

    window.addEventListener("sp-request-unsaved-state", handleRequest);
    return () =>
      window.removeEventListener("sp-request-unsaved-state", handleRequest);
  }, [dirty]);

  // Listen for discard command from the header's "Leave page" confirm
  useEffect(() => {
    const handleForceDiscard = () => {
      window.dispatchEvent(
        new CustomEvent("sp-unsaved-changes", { detail: { dirty: false } }),
      );
    };

    window.addEventListener(
      "sp-force-discard-unsaved-changes",
      handleForceDiscard,
    );
    return () =>
      window.removeEventListener(
        "sp-force-discard-unsaved-changes",
        handleForceDiscard,
      );
  }, []);
}
